import { CSSProperties, FC, ReactNode } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { FinancialOverviewSectionHeader } from '@/shared/components/financial-overview';

interface AnalyticsSectionCardProps {
    ariaLabel?: string;
    children: ReactNode;
    contentStyle?: CSSProperties;
    description?: ReactNode;
    extra?: ReactNode;
    icon?: ReactNode;
    id?: string;
    title: ReactNode;
}

const AnalyticsSectionCard: FC<AnalyticsSectionCardProps> = ({
    ariaLabel,
    children,
    contentStyle,
    description,
    extra,
    icon,
    id,
    title,
}) => {
    const { token } = useAntDesignTheme();

    return (
        <section
            aria-label={ariaLabel}
            id={id}
            style={{
                background: token.colorBgContainer,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            <header
                style={{
                    borderBottom: `1px solid ${token.colorBorderSecondary}`,
                    padding: '1.125rem',
                }}
            >
                <FinancialOverviewSectionHeader actions={extra} description={description} icon={icon} title={title} />
            </header>
            <div style={contentStyle}>{children}</div>
        </section>
    );
};

export default AnalyticsSectionCard;
export type { AnalyticsSectionCardProps };
